import { render, staticRenderFns } from "./FaqIndex.vue?vue&type=template&id=b55d34de&scoped=true"
import script from "./FaqIndex.vue?vue&type=script&lang=js"
export * from "./FaqIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55d34de",
  null
  
)

export default component.exports